import { useEffect, useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import { usePageVisibility } from 'react-page-visibility';
import { selectTwilioClient } from 'models/twilio';
import safeUpdateIdleStatus from '../utils/safeUpdateIdleStatus';

const useIdleAndActiveTabHook = () => {
  const visibility = usePageVisibility();
  const twilioClient = useSelector(selectTwilioClient, shallowEqual);

  const updateIdleStatus = useCallback(async (isIdle: boolean) => {
    await safeUpdateIdleStatus(twilioClient?.user, isIdle);
  }, [twilioClient?.user]);

  useEffect(() => {
    updateIdleStatus(!visibility);
  }, [visibility, updateIdleStatus]);

  const handleOnIdle = useCallback(() => {
    updateIdleStatus(true);
  }, [updateIdleStatus]);

  const handleOnActive = useCallback(() => {
    updateIdleStatus(false);
  }, [updateIdleStatus]);

  useIdleTimer({
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    timeout: 1000 * 60 * 30,
  });
};

export default useIdleAndActiveTabHook;
